.container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.container > header {
  display: flex;
  gap: 4px;
}

.unlisted {
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding-block: 1px;
  padding-inline: 4px;
  background: #fd0;
}

.datetimeAnchor {
  color: #444;
}

.datetimeAnchor:hover {
  color: #444;
  text-decoration: revert;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tags > li,
.subject {
  border: 1px solid var(--border-color);
  border-radius: 4px;
}

.tags > li {
  display: inline-block;
  padding-block: 1px;
  padding-inline: 4px;
}

.tags > li > ::before {
  content: '#';
}

.subjectContainer {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.subjectList {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.subject {
  display: block;
  padding: 12px;
}

.subject figure {
  display: flex;
  gap: 8px;
}

.subject figcaption {
  overflow: auto;
  overflow-wrap: anywhere;
}

.subjectThumb {
  --max-width: calc(100vw / 3);
  max-width: var(--max-width);
  --max-height: 50vh;
  max-height: var(--max-height);
  object-fit: contain;
}

:global(.react-loading-skeleton).subjectThumb {
  height: min(calc(var(--max-width) * 16 / 9), var(--max-height));
  width: min(calc(var(--max-height) * 9 / 16), var(--max-width));
}

.subjectList .subjectThumb {
  --max-height: 25vh;
}

.subjectAuthorName:hover {
  text-decoration: underline;
}

.subjectAuthorAvatar {
  max-width: 1.5em;
  max-height: 1.5em;
}

.subject figure > figcaption > cite {
  font-weight: bold;
}

.note {
  white-space: pre-wrap;
}

.errorContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.errorContainer > button {
  inline-size: fit-content;
}
